// extracted by mini-css-extract-plugin
export default {"List":"Legend_List__r+ue+","ListItem":"Legend_ListItem__0JtCM","ColorChip":"Legend_ColorChip__pAlVb","AvatarImage":"Legend_AvatarImage__hVt1p","ItemName":"Legend_ItemName__QxdF0"};